var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parlay-free"},[(!_vm.showDesglose)?[_c('ParlayInfo',{on:{"show":_vm.show}})]:_vm._e(),(_vm.showDesglose)?[_c('ParlayDesglose',{on:{"show":_vm.show}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }